// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__NfV8M","emails":"CreateEditClinics_emails__2PBxr","emailTagLabel":"CreateEditClinics_emailTagLabel__36DW0"};